// src-mlr-chakra/components/footer/footer.component.js
import { FooterController } from '@common/components/footer/footer.component';
import template from './footer.tpl.html'; // Comment this out for test
import './footer.scss';

class MlrFooterController extends FooterController {

  async $onInit() {

    await super.$onInit(); // This populates this.page
    this.year = this.DayjsService.now().format('YYYY');
  }
}

// --- Component Definition ---
class MlrFooterComponent {
  constructor() {
    this.template = template;
    this.controller = MlrFooterController;
  }
}

export default angular
  .module('mlrfooter.component', [])
  .component('mlrfooter', new MlrFooterComponent())
  .name;